const consultation = {
  // قسم البطل
  heroTitle: 'استشارة عقارية احترافية',
  heroSubtitle: 'احجز استشارتك عبر الإنترنت مع خبراء عقاريين معتمدين. تواصل معنا عن بُعد للحصول على إرشادات مهنية.',
  certifiedExperts: 'خبراء معتمدون',
  onlineBooking: 'حجز عبر الإنترنت',
  satisfaction: 'رضا 100%',

  // قسم الباقات
  packageTitle: 'اختر باقة الاستشارة الخاصة بك',
  packageSubtitle: 'اختر باقة الاستشارة التي تناسب احتياجاتك العقارية وميزانيتك',
  mostPopular: 'الأكثر شعبية',

  // الباقات
  packages: {
    basic: {
      name: 'استشارة عقارية أساسية',
      duration: '60 دقيقة',
      description: 'مثالية للمشترين لأول مرة أو الباحثين عن نصائح عقارية عامة',
      feature1: 'استشارة فيديو عبر الإنترنت',
      feature2: 'نظرة عامة على سوق جدة والاتجاهات',
      feature3: 'إرشادات تقييم العقارات',
      feature4: 'خيارات التمويل الأساسية',
      feature5: 'ملخص بالبريد الإلكتروني للمتابعة',
    },
    premium: {
      name: 'تحليل استثماري متميز',
      duration: '90 دقيقة',
      description: 'استشارة شاملة عبر الإنترنت للمستثمرين الجادين ومحترفي العقارات',
      feature1: 'استشارة فيديو عبر الإنترنت',
      feature2: 'تحليل مفصل لسوق جدة',
      feature3: 'حسابات عائد الاستثمار',
      feature4: 'تقييم المخاطر',
      feature5: 'توصيات عقارية مخصصة',
      feature6: 'تقرير استثماري مكتوب',
      feature7: 'دعم متابعة عبر الإنترنت لمدة 30 يوماً',
    },
    luxury: {
      name: 'استشارة العقارات الفاخرة',
      duration: 'ساعتان',
      description: 'استشارة حصرية عبر الإنترنت للمعاملات العقارية الراقية',
      feature1: 'استشارة فيديو متميزة عبر الإنترنت',
      feature2: 'رؤى سوق جدة الفاخرة',
      feature3: 'وصول حصري للعقارات',
      feature4: 'جولات افتراضية للعقارات',
      feature5: 'استراتيجيات التفاوض',
      feature6: 'الآثار القانونية والضريبية',
      feature7: 'إدارة علاقات مستمرة عبر الإنترنت',
    },
  },

  // المميزات
  easyScheduling: 'جدولة سهلة عبر الإنترنت',
  bookConsultation: 'احجز استشارة',
  instantBooking: 'حجز فوري',
  instantBookingDesc: 'احجز استشارتك على الفور مع التوافر في الوقت الفعلي',
  autoReminders: 'تذكيرات تلقائية',
  autoRemindersDesc: 'احصل على تذكيرات بالبريد الإلكتروني والرسائل النصية قبل موعدك',
  videoMeetings: 'اجتماعات الفيديو',
  videoMeetingsDesc: 'انضم إلى الاستشارات عبر مكالمة الفيديو أو الهاتف',
  calendarSync: 'مزامنة التقويم',
  calendarSyncDesc: 'المزامنة التلقائية مع تقويمات Google أو Outlook أو Apple',

  // قسم النموذج
  formTitle: 'احجز استشارتك',
  fullName: 'الاسم الكامل',
  fullNameRequired: 'الاسم الكامل *',
  email: 'البريد الإلكتروني',
  emailRequired: 'البريد الإلكتروني *',
  phone: 'رقم الهاتف',
  phoneRequired: 'رقم الهاتف *',
  propertyType: 'نوع العقار',
  propertyTypeRequired: 'نوع العقار *',
  budgetRange: 'نطاق الميزانية',
  budgetRangeRequired: 'نطاق الميزانية *',
  message: 'رسالة (اختياري)',
  preferredTimeSlot: 'الوقت المفضل',
  consultationPackage: 'باقة الاستشارة',

  // العناصر النائبة
  enterFullName: 'أدخل اسمك الكامل',
  enterEmail: 'بريدك.الإلكتروني@example.com',
  enterPhone: '+966 XX XXX XXXX',
  selectPropertyType: 'اختر نوع العقار',
  selectBudgetRange: 'اختر نطاق الميزانية',
  enterMessage: 'أخبرنا عن احتياجاتك العقارية...',

  // أنواع العقارات
  house: 'منزل',
  apartment: 'شقة',
  condo: 'شقة فاخرة',
  townhouse: 'تاون هاوس',
  commercial: 'تجاري',
  investmentProperty: 'عقار استثماري',

  // نطاقات الميزانية
  under200k: 'أقل من 200 ألف دولار',
  range200to500k: '200 - 500 ألف دولار',
  range500kto1m: '500 ألف - 1 مليون دولار',
  range1to2m: '1 - 2 مليون دولار',
  over2m: 'أكثر من 2 مليون دولار',

  // الأزرار
  backToPackages: 'العودة إلى الباقات',
  chooseTimeSlot: 'اختر الوقت',
  openCalendar: 'افتح التقويم واحجز',

  // صندوق المعلومات
  quickSetup: 'إعداد سريع مطلوب',
  quickSetupDesc: 'املأ هذا النموذج البسيط للبدء باستشارتك. سيتواصل معك أحد خبراء العقارات لدينا قريباً.',

  // رسائل التنبيه
  fillAllFields: 'يرجى ملء جميع الحقول المطلوبة قبل الجدولة.',
  paymentFailed: 'فشل معالجة دفع الاستشارة. يرجى المحاولة مرة أخرى.',
  scheduledSuccess: 'تم جدولة الاستشارة بنجاح! ستتلقى بريداً إلكترونياً للتأكيد قريباً.',

  // صفحة النجاح
  successTitle: 'تم جدولة الاستشارة!',
  successMessage: 'تم جدولة استشارتك بنجاح.',
  successDetails: 'أرسلنا بريداً إلكترونياً للتأكيد يحتوي على جميع التفاصيل. سيتواصل معك خبيرنا قريباً لتأكيد موعدك.',
  backToHome: 'العودة إلى الصفحة الرئيسية',
  viewConsultations: 'عرض استشاراتي',
};

export default consultation;
